<template>
	<div class="form-group row">
		<label class="col-sm-3 col-form-label">Current Level</label>
		<div class="col-sm-9">
			<b-input-group>
				<b-form-select v-model="currentLevel" :options="levels"></b-form-select>
				<b-input-group-append v-if="currentLevel < 20">
					<b-button variant="primary" @click="levelUp"><font-awesome-icon icon="level-up-alt"></font-awesome-icon> Level Up</b-button>
				</b-input-group-append>
			</b-input-group>
			
		</div>
	</div>
</template>

<script>
export default {
	methods:{
		levelUp: function() {
			if(this.currentLevel == this.highestLevel){
				this.$emit('addLevel')
			}
			this.currentLevel++
		}
	},
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		currentLevel: {
			get: function() {
				return this.Character.Level
			},
			set: function(value) {
				this.$store.commit('setCharacterProp',[
					{
						key: 'Level',
						val: value,
					}
				])
			}
		},
		highestLevel: function(){
			return Object.keys(this.$store.state.Character.Levels).length
		},
		levels: function() {
			let levels = Object.keys(this.Character.Levels)
			return levels
		}
	},
}
</script>

<style scoped>

</style>